class AppSnackBarService {
  private model = {
    show: false,
    color: "",
    text: "",
    timeout: 4000
  };

  getModel() {
    return this.model;
  }

  success(text, timeout = 4000) {
    this.model.color = "success";
    this.showSnackbar(text, timeout);
  }

  warning(text, timeout = 4000) {
    this.model.color = "warning";
    this.showSnackbar(text, timeout);
  }

  error(text, timeout = 4000) {
    this.model.color = "red";
    this.showSnackbar(text, timeout);
  }

  private showSnackbar(text: any, timeout: number) {
    this.model.text = text;
    this.model.show = true;
    this.model.timeout = timeout;
  }
}

export default new AppSnackBarService();
